import { createSlice } from '@reduxjs/toolkit';
import uploadReportImgs from '@custom/rtk-apis/report/uploadReportImgs';

const initialState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
};

const uploadReportImgsSlice = createSlice({
  name: 'uploadReportImgsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadReportImgs.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadReportImgs.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(uploadReportImgs.rejected, (state, { error }) => {
        state.loading = false;
        state.status = 'ERROR';
        state.msg = error.message;
      });
  },
});

export default uploadReportImgsSlice.reducer;
